import baseApi from "src/config/api/base"
import { ApplyRequest, ApplyResponse, ResendOtpRequest, ResendOtpResponse } from "./types/apply"
import { Apply2Request, Apply2Response } from "./types/apply2"
import {Apply3Request, Apply3Response} from "./types/apply3"
import { BaseRequest, BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"
import { GetCitiesResponse } from "./types/city"
import { GetBranchesRequest, GetBranchesResponse } from "./types/branch"
import { Apply4Request, Apply4Response } from "./types/apply4"
import { GetConfigListRequest, GetConfigListResponse } from "./types/configList"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body : {
          tckn: body,
          functionCode: "SPE0026",
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getConfigList: builder.mutation<GetConfigListResponse, GetConfigListRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body : {
          functionCode: "SPE0026",
          cid: body.cid,
          NextTransactionUrl: "Facebook/SMPUConfig/GetConfigListWithFunctionCode1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body : {
          tckn : body.tckn,
          TokenSessionId : body.TokenSessionId,
          NextTransactionUrl: "Facebook/LeadKobi/GetCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),    
    refreshCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body : {
          tckn : body.tckn,
          TokenSessionId : body.TokenSessionId,
          NextTransactionUrl: "Facebook/LeadKobi/RefreshCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply: builder.mutation<ApplyResponse, ApplyRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    resendOtp: builder.mutation<ResendOtpResponse, ResendOtpRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply2: builder.mutation<Apply2Response, Apply2Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body
      }),      
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply3 : builder.mutation<Apply3Response, Apply3Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body
      }),      
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCities: builder.mutation<GetCitiesResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/CitiesList1",
          TokenSessionId: body
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getBranches: builder.mutation<GetBranchesResponse, GetBranchesRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          ilKodu: body.cityId,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/BranchesList1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply4 : builder.mutation<Apply4Response, Apply4Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          subeKodu: body.subeKodu,
          selectedProduct: body.selectedProduct,
          NextTransactionUrl: "Facebook/LeadKobi/Apply4",
          TokenSessionId: body.TokenSessionId
        }
      }),      
      transformResponse: (response: string) => JSON.parse(response)
    }),
  })
})

export const { useGetTokenByTckn1Mutation, useGetConfigListMutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApplyMutation, useResendOtpMutation, useApply2Mutation,useApply3Mutation, useGetCitiesMutation, useGetBranchesMutation, useApply4Mutation } = api

export default api
